import { render, staticRenderFns } from "./watch.vue?vue&type=template&id=2f97bf42&scoped=true"
import script from "./watch.vue?vue&type=script&lang=js"
export * from "./watch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97bf42",
  null
  
)

export default component.exports